module.exports = __webpack_public_path__ + "static/assets/eac5530a4747ad43534a7f5049f780af.png";